export function scrollToTop(ref) {
    function scroll(ref) {
        if (!ref) return;

        ref.scrollIntoView({behavior: 'smooth'});
    }
    setTimeout(() => {
        const trigger = setTimeout(() => {
            scroll(ref);
        }, 100);

        return () => clearTimeout(trigger);
    }, 100);
}